'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { useSelector } from 'react-redux';
import { getCookies, deleteCookie } from 'cookies-next';
import { checkIsSocialLogin } from '@zeus/shared';
import { clearReduxStorage } from '../../../utils/LocalStorage';
import { sendGAEvent } from '@next/third-parties/google';
import { sendEventToPostHog } from '../../../utils/UtilFunctions';
import { EventAction, EventType } from '../../../config/GAConstants';
import { RootState } from '@store/online/index';
import useAuthUser from './AuthUser';

const PRESERVED_COOKIES = new Set([
  'tenantName',
  'selectedBusinessId',
  'isQr',
  'menuOnlyFlow',
  'selectedRestaurantAddressNew',
]);

function googleLogout() {
  const redirectUri = `${process.env.NEXT_PUBLIC_ONLINE_URL}/login`;
  const url = `${
    process.env.NEXT_PUBLIC_COGNITO_DOMAIN
  }/logout?identity_provider=Google&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&client_id=${
    process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID
  }&logout_uri=${encodeURIComponent(redirectUri)}`;
  window.location.href = url;
}

export function useSignout() {
  const router = useRouter();
  const isQr = useSelector((state: RootState) => state.restaurant.isQr);
  const qrId = useSelector((state: RootState) => state.restaurant.qrId);
  const username = useAuthUser()?.username || '';

  return useCallback(() => {
    sendGAEvent(EventType.EVENT, EventAction.OL_LOGIN_SIGNUP_SIGNOUT);
    sendEventToPostHog(EventType.EVENT, EventAction.OL_LOGIN_SIGNUP_SIGNOUT);
    const allCookies = getCookies();
    Object.keys(allCookies).forEach((cookieName) => {
      if (!PRESERVED_COOKIES.has(cookieName)) deleteCookie(cookieName);
    });
    clearReduxStorage();
    if (username && checkIsSocialLogin(username)) {
      googleLogout();
    } else if (isQr) {
      router.push(`/qr-ordering/${qrId}`);
    } else {
      router.push('/login');
    }
  }, [router, isQr, qrId, username]);
}
